import {
  has,
  get,
  set,
  size,
  flow,
  values,
  reduce,
  groupBy,
  orderBy
} from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import { fetchReservationsOrderItems } from '../../sagas/routines';
import { resetReservationsOrderItems } from '../../actions/order-items';

const initialState = {
  ordersByReservation: null,
  meta: { page: 1, count: 0 },
  fetching: false,
  fetched: false,
  fetchingError: null
};

const groupByOrder = reduce(
  (orders, { notes, totalQuantity, picklistSnapshot, ...orderItem }) => {
    const {
      createdAt,
      reservationId,
      reservationOrderId,
      publicUserId,
      clientId,
      trackingMethodId,
      picklistId
    } = orderItem;
    if (!has(`${reservationOrderId}`, orders))
      return set(
        `${reservationOrderId}`,
        {
          id: reservationOrderId,
          notes,
          totalQuantity,
          reservationId,
          publicUserId,
          clientId,
          trackingMethodId,
          picklistId,
          picklistSnapshot,
          items: [orderItem],
          createdAt
        },
        orders
      );

    return set(
      `${reservationOrderId}.items`,
      [...get(`${reservationOrderId}.items`, orders), orderItem],
      orders
    );
  },
  {}
);

const fetchHandler = routine => ({
  [routine.REQUEST]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    ordersByReservation: flow(
      groupByOrder,
      values,
      orderBy('picklistSnapshot.position', 'asc'),
      groupBy('reservationId')
    )(response.items),
    meta: { ...response.meta, count: size(response.items) }
  }),
  [routine.FAILURE]: (state, { payload: error }) =>
    set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const resetHandler = action => ({
  [action.toString()]: () => initialState
});

export default createReducer(initialState, {
  ...fetchHandler(fetchReservationsOrderItems),
  ...resetHandler(resetReservationsOrderItems)
});
